import React, {Component} from 'react'
import {reduxForm, Field} from 'redux-form'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {NavLink} from 'react-router-dom'
import DatePickerFormComponent from '../components/redux-form/DatePickerFormComponent'
import CategoriesSelectFormComponent from '../components/redux-form/CategoriesSelectFormComponent'
import VirtualizedSelectFormComponent from '../components/redux-form/VirtualizedSelectFormComponent'
import CategoriesTreeSelectFormComponent from '../components/redux-form/CategoriesTreeSelectFormComponent'
import DropdownTreeSelect from 'react-dropdown-tree-select'

const mapStateToProps = (state) => {
  return {
    userFormValues: state.form.backofficeUserCreate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

const checkObjectProp = (obj, props) => {
  let splited = props.split('.')
  let temp = obj
  for (let index in splited) {
    if (typeof temp[splited[index]] === 'undefined') return false
    temp = temp[splited[index]]
  }
  return true
}

const isResident = (categories) => {
  let filteredCategories = categories.filter(item => {
    return item.resident
  })

  return filteredCategories.length > 0
}

const isParkPlaceInDifferentAddress = (categories) => {
  let filteredCategories = categories.filter(item => {
    return item.parkingInDifferentPlace
  })

  return filteredCategories.length > 0
}
const isParkPlaceMultiple = (categories) => {
  let filteredCategories = categories.filter(item => {
    return item.multipleParkingSpace
  })

  console.log(filteredCategories)
  return filteredCategories.length > 0
}

const isWorker = (categories) => {
  let filteredCategories = categories.filter(item => {
    return item.worker
  })

  return filteredCategories.length > 0
}
const isWorkerPerson = (categories) => {
  console.log(categories)
  let filteredCategories = categories.filter(item => {
    return item.workerPerson
  })

  return filteredCategories.length > 0
}


// crea utente
class BackOfficeUserCreateScreen extends Component {
  static propTypes = {
    onFiscalCodeChange: PropTypes.func,
    onSearchFiscalCodeAndFormFilling: PropTypes.func,
    searchingFiscalCode: PropTypes.bool,
    foundFiscalCode: PropTypes.object,
    searchingFiscalCodeInitialized: PropTypes.bool,
    selectedParkSpaces: PropTypes.array,
    onAddParkingSpace: PropTypes.func,
    onRemoveParkSpace: PropTypes.func,
    onMultipleParkingSpaceAddressSelected: PropTypes.func
  }

  render () {
    const {error, handleSubmit, onFiscalCodeChange, onSearchFiscalCodeAndFormFilling, searchingFiscalCode, foundFiscalCode} = this.props
    return (<div className="col-md-12">
      <div className="panel panel-default panel-border">
        <div className="panel-body">
          <h2 className="title">Crea Utente</h2>
          <form onSubmit={handleSubmit}>
            <div className="box">
              {/* Inizio informazioni generali utente */}
              <fiedset>
                <div className="titolo-categoria">
                  <legend className="text-left">Informazioni generali</legend>
                </div>
                <div className="row">
                  <div className="col-md-6 text-left">
                    <label>Codice Fiscale</label>
                    <Field
                      onBlur={onSearchFiscalCodeAndFormFilling}
                      onChange={onFiscalCodeChange}
                      component="input"
                      name="fiscalCode"
                      type="text"
                      className="resident-login"
                      required
                    />
                  </div>
                  {this.props.searchingFiscalCodeInitialized && (
                    <div className="col-md-6">
                      <label />
                      <div className="text-left" style={{marginTop: 12}}>
                        {searchingFiscalCode ? (
                          <h4 className="text-info">Ricerca Utente in corso...</h4>
                        ) : ( ( this.props.foundFiscalCode != null && (this.props.foundFiscalCode.mergeUser || this.props.foundFiscalCode.adjustmentUser) ) ? (
                            <h4 className="text-success">Utente trovato in database</h4>
                          ) : (
                            <h4 className="text-danger">Utente non trovato</h4>
                          )
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-6 text-left">
                    <label>Nome</label>
                    <Field component="input" name="firstName" type="text" className="resident-login" required />
                  </div>
                  <div className="col-md-6 text-left">
                    <label>Cognome</label>
                    <Field component="input" name="lastName" type="text" className="resident-login" required />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 text-left">
                    <label>E-mail</label>
                    <Field component="input" name="email" type="text" className="resident-login" />
                  </div>
                  <div className="col-md-6 text-left">
                    <label>Telefono Mobile</label>
                    <Field
                      component="input"
                      name="phone"
                      type="text"
                      placeholder="333 333 3333"
                      className="resident-login" />
                  </div>
                </div>
              </fiedset>
              {/* Fine informazioni generali utente */}

              {/* Inizio Categorie Utente */}
              <div className="row">
                <div className="col-md-6 text-left">
                  <label>Seleziona Tipologie Utente</label>
                  <Field
                    mode="multiSelect"
                    required
                    options={this.props.categoryOptions}
                    component={CategoriesTreeSelectFormComponent}
                    onCategoriesChange={(categories) => this.props.onCategoriesChange(categories)}
                    name="userCategories"
                    placeholder="Seleziona Categorie Utente" />
                </div>
              </div>
              {/* Fine Categorie Utente */}

              {/* Inizio Informazioni Residente */}
              {isResident(this.props.selectedCategories) &&
              <fiedset>
                <div className="titolo-categoria">
                  <legend className="text-left">Residente</legend>
                </div>
                <div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Data di Nascita</label>
                      <Field component={DatePickerFormComponent} name="birthDate" className="resident-login" required />
                    </div>
                    <div className="col-md-6 text-left">
                      <label>Città di Nascita</label>
                      <Field
                        name="birthPlace"
                        options={this.props.comuni} component={VirtualizedSelectFormComponent} required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Sesso</label><br />
                      <label className="sex">
                        <Field name="sex" component="input" type="radio" value="M" required /> {' '} Uomo
                      </label>
                      {' '}
                      <label>
                        <Field name="sex" component="input" type="radio" value="F" required /> {' '} Donna
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-7 text-left">
                      <label>Indirizzo di Residenza/Domicilio</label>
                      {(!this.props.searchingFiscalCode &&
                        this.props.searchingFiscalCodeInitialized &&
                        // !isParkPlaceInDifferentAddress(this.props.selectedCategories)) && (
                        <Field
                          onChange={(event, data) => this.props.onAddressSelected(data)}
                          name="residenceAddress"
                          options={
                            this.props.addresses.data.map(item => {
                              return { label: item.name, value: item.id }
                            })}
                          component={VirtualizedSelectFormComponent}
                          required />
                      )}
                      {/*
                        !this.props.searchingFiscalCode &&
                        this.props.searchingFiscalCodeInitialized &&
                        isParkPlaceInDifferentAddress(this.props.selectedCategories) && (
                        <Field name="residenceAddress" component="input" type="text" className="resident-login" required />
                        )*/}
                    </div>
                    <div className="col-md-2 text-left">
                      <label>N° Civico</label>
                      <Field
                        component="input"
                        name="residenceCivicNumber"
                        type="text"
                        placeholder="N°"
                        className="resident-login"
                        required />
                    </div>

                    {this.props.selectedArea &&
                    // !isParkPlaceInDifferentAddress(this.props.selectedCategories) &&
                    <div className="col-md-3 text-left">
                      <label>Area Selezionata</label>
                      <div style={{marginTop: 12}}>
                        <h4>{this.props.selectedArea.name}</h4>
                      </div>
                    </div>
                    }
                  </div>

                  <div className="row">
                    <div className="col-md-12 text-info text-left" style={{marginTop: 10, marginBottom: 10}}>
                      I campi a seguire sono da compilare solo nel caso l'indirizzo precedente rappresenti il domicilio
                    </div>
                    <div className="col-md-7 text-left">
                      <label>Indirizzo di Residenza</label>
                      <Field
                        component="input"
                        name="secondaryResidenceAddress"
                        type="text"
                        placeholder="Indirizzo di residenza"
                        className="resident-login"
                      />
                    </div>
                    <div className="col-md-3 text-left">
                      <label>Città</label>
                      <Field
                        name="secondaryResidenceCity"
                        options={this.props.comuniWithoutLodi}
                        component={VirtualizedSelectFormComponent}
                      />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>CAP</label>
                      <Field
                        component="input"
                        name="secondaryResidenceCap"
                        type="text"
                        placeholder="CAP"
                        className="resident-login"
                      />
                    </div>
                  </div>

                  {isParkPlaceInDifferentAddress(this.props.selectedCategories) && (
                    <div className="row">
                      <div className="col-md-12 text-info text-left" style={{marginTop: 10, marginBottom: 10}}>
                        Questa categoria utente ha uno o più posti auto in un luogo diverso da quello di residenza/domicilio
                      </div>
                      {isParkPlaceMultiple(this.props.selectedCategories) ? (
                        <div>
                          <div className="col-md-12 text-left">
                            <a onClick={this.props.onAddParkingSpace} className="btn btn-xs btn-info">Aggiungi Posto Auto</a>
                          </div>
                          {this.props.selectedParkSpaces.map((item, index) => {
                            return (
                              <div className="col-md-12" key={`park-space-${index}`}>
                                <div className="col-md-1">
                                  <a className="btn btn-xs btn-danger" onClick={() => this.props.onRemoveParkSpace(index)}>Rimuovi</a>
                                </div>
                                <div className="col-md-7 text-left">
                                  <label>
                                    Indirizzo del Posto Auto {index + 1}
                                  </label>
                                  <Field
                                    onChange={(event, data) => this.props.onMultipleParkingSpaceAddressSelected(data, index)}
                                    name={'parkingSpaceAddress' + index}
                                    options={
                                      this.props.addresses.data.map(item => {
                                        return { label: item.name, value: item.id }
                                      })} component={VirtualizedSelectFormComponent} required />
                                </div>
                                {item.area && <div className="col-md-3 text-left">
                                  <label>Area Selezionata</label>
                                  <div style={{marginTop: 12}}>
                                    <h4>{item.area.name}</h4>
                                  </div>
                                </div>}
                              </div>
                            )
                          })}
                        </div>
                      ) : (
                        <React.Fragment>
                          <div className="col-md-7 text-left">
                            <label>
                              Indirizzo del Posto Auto
                            </label>
                            <Field
                              onChange={(event, data) => this.props.onParkingSpaceAddressSelected(data)}
                              name="parkingSpaceAddress"
                              options={
                                this.props.addresses.data.map(item => {
                                  return { label: item.name, value: item.id }
                                })} component={VirtualizedSelectFormComponent} required />
                          </div>
                          {this.props.selectedParkingSpaceArea && <div className="col-md-3 text-left">
                            <label>Area Selezionata</label>
                            <div style={{marginTop: 12}}>
                              <h4>{this.props.selectedParkingSpaceArea.name}</h4>
                            </div>
                          </div>}
                          {/* <div className="col-md-2 text-left">
                            <label>N° Civico</label>
                            <Field
                              component="input"
                              name="residenceCivicNumber"
                              type="text"
                              placeholder="N°"
                              className="resident-login"
                              required />
                          </div> */}
                        </React.Fragment>
                      )}
                    </div>
                  )}

                  {/* <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Seleziona Area di Residenza</label>
                      <Field name="residenceAreaId" className="form-control" component="select" required>
                        <option value={''}>Seleziona Area</option>
                        {this.props.areas.map((item, index) =>
                          <option key={item.id + '-' + index} value={item.id}>{item.name}</option>)}
                      </Field>
                    </div>
                    <div className="col-md-4 text-left">
                      <label>Indirizzo di Residenza</label>
                      <Field
                        component="input"
                        name="residenceAddress"
                        type="text"
                        placeholder="Via X"
                        className="resident-login"
                        required />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>N° Civico</label>
                      <Field
                        component="input"
                        name="residenceCivicNumber"
                        type="text" placeholder="N°"
                        className="resident-login"
                        required />
                    </div>
                  </div> */}
                </div>
              </fiedset>}
              {/* Fine Informazioni Residente */}

              {/* Inizio Informazioni Lavoratore */}
              {isWorkerPerson(this.props.selectedCategories) &&
              <fiedset>
                <div className="titolo-categoria">
                  {this.props.selectedCategories.map((item, index) => <legend
                      key={item.id + '-' + index}
                      className="text-left">{item.label}</legend>)}
                </div>
                <div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Nome Azienda</label>
                      <Field
                          component="input"
                          name="companyName"
                          type="text"
                          placeholder="Nome Organizzazione..."
                          className="resident-login"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-7 text-left">
                      <label>Sede Azienda/Residenza</label>
                      <Field
                        className="form-control"
                        name="workAddress"
                        component="input"
                        type="text"
                      />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>N° Civico</label>
                      <Field
                        component="input"
                        name="workCivicNumber"
                        type="text"
                        placeholder="N°"
                        className="resident-login"
                      />
                    </div>
                  </div>

                  <div>
                    <div className="row">
                      <div className="col-md-6 text-left">
                        <label>Partita IVA</label>
                        <Field
                            component="input"
                            name="vatNumber"
                            type="text"
                            placeholder="0123456789"
                            className="resident-login"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </fiedset>}

              {isWorker(this.props.selectedCategories) &&
              <fiedset>
                <div className="titolo-categoria">
                  {this.props.selectedCategories.map((item, index) => <legend
                    key={item.id + '-' + index}
                    className="text-left">{item.label}</legend>)}
                </div>
                <div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Nome Azienda</label>
                      <Field
                        component="input"
                        name="companyName"
                        type="text"
                        placeholder="Nome Organizzazione..."
                        className="resident-login"
                        required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-7 text-left">
                      <label>Indirizzo Sede</label>
                      <Field
                        component="input"
                        name="workAddress"
                        type="text"
                        placeholder="Indirizzo di residenza"
                        className="resident-login"
                      />
                    </div>
                    <div className="col-md-3 text-left">
                      <label>Città Sede</label>
                      <Field
                        name="workCity"
                        options={this.props.comuni}
                        component={VirtualizedSelectFormComponent}
                      />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>CAP</label>
                      <Field
                        component="input"
                        name="workCap"
                        type="text"
                        placeholder="CAP"
                        className="resident-login"
                      />
                    </div>
                  </div>
                  {/*<div className="row">
                    <div className="col-md-7 text-left">
                      <label>Sede Azienda</label>
                      <Field
                        onChange={(event, data) => this.props.onAddressSelected(data)}
                        name="workAddress" options={
                        this.props.addresses.data.map(item => {
                            return { label: item.name, value: item.id }
                          }
                        )} component={VirtualizedSelectFormComponent} required />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>N° Civico</label>
                      <Field
                        component="input"
                        name="workCivicNumber"
                        type="text"
                        placeholder="N°"
                        className="resident-login"
                        required />
                    </div>

                    {this.props.selectedArea && <div className="col-md-3 text-left">
                      <label>Area Selezionata</label>
                      <div style={{marginTop: 12}}>
                        <h4>{this.props.selectedArea.name}</h4>
                      </div>
                    </div>}
                  </div>*/}

                  <div>
                    <div className="row">
                      <div className="col-md-6 text-left">
                        <label>Partita IVA</label>
                        <Field
                          component="input"
                          name="vatNumber"
                          type="text"
                          placeholder="0123456789"
                          className="resident-login"
                          required />
                      </div>
                    </div>
                  </div>
                </div>
              </fiedset>}
              {/* Fine Informazioni Lavoratore/Titolare di Attività Economica */}

              {this.props.loading && <div className="well">Creazione Utente in Corso...</div> }

              {this.props.userCreateError && <div className="panel panel-danger">
                Errore nella creazione dell'utente!
                {this.props.userCreateResult.error === 'User already exists' &&
                <div>Codice Fiscale o indirizzo e-mail già inserito in database</div>}
              </div>}

              {this.props.userCreateSuccess && <div>
                <div className="row">
                  <div className="col-md-4 col-md-offset-4 ">
                    <div className="contrassegno">
                      <h4 className="contrassegno-h">Utente creato correttamente!</h4>
                      <p>
                        <NavLink
                          to={'/backoffice/users'}
                          className="btn btn-resident btn-lg btn-green btn-lg btn-back-profile"
                          activeClassName={'active'}>Indietro</NavLink>
                        <NavLink
                          to={'/backoffice/users/' + this.props.userCreateResult.data.id}
                          className="btn btn-resident btn-lg btn-green btn-back-profile"
                          activeClassName={'active'}>Vai Al Profilo</NavLink>
                      </p>
                    </div>
                  </div>
                </div>
              </div>}
              <p>
                <button type="submit" className="btn btn-resident btn-lg btn-green">
                  Crea Utente
                </button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>)
  }
}

BackOfficeUserCreateScreen = reduxForm({
  enableReinitialize: true,
  form: 'backofficeUserCreate'
})(BackOfficeUserCreateScreen)

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserCreateScreen)



// WEBPACK FOOTER //
// ./src/screens/BackOfficeUserCreateScreen.js